<template>
  <div class="home w-100 container-adviser">

      <div class='row justify-content-center text-center'>
        <div class="col-md-3 col-11 parent">
          <div class=" adviser first">
            <div style="margin:0;" class="row justify-content-center align-items-center cap">
                <button type="button" name="button" class="adviser-link2 gafa-fhr">GAFA FHR</button>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-11 parent">
          
          <div class=" adviser second">
            <div style="margin:0;" class="row justify-content-center align-items-center cap">
                <button type="button" onclick="location.href='http://crm.gafa.co.nz'" name="button" class="adviser-link2" >CRM Login</button>
            </div>
          </div>
          
        </div>
        <div class="col-md-3 col-11 parent">
          <div class=" adviser third  ">
            <div style="margin:0;" class="row justify-content-center align-items-center cap">
              <router-link to="/Utilities"><button class="adviser-link2">GAFA Utilities</button></router-link>
            </div>
          </div>
        </div>
      </div>
 

  </div>
</template>

<script>
// @ is an alias to /src
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'AdviserHub',
  data(){
    return{
      
    }
  },
  components: {
  },
  computed:{
   ...mapState(['token'])
  },
  methods:{
      ...mapMutations(['setLogIn','checkLogIn']) 
      
  },
  created(){    
  }
}
</script>
<style>

  hide the gafa-fhr form ****/
#cognito{
  display: none;
}

.container-adviser{
  margin-top:6rem;
}

/****  advider-hub.php  ****/
.parent {
  height: 200px;
  width: 300px;
  padding: 0px!important;
  margin-left: 10px;
  margin-right: 10px;
  overflow: hidden;
}

.adviser{
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  transition: all 1.5s ease-in-out;
}

.adviser:hover{
  transform: scale(1.1);
}
.first{
  background-image: url("../assets/GAFA-FHR.jpg");
}
.second{
  background-image: url("../assets/CRM-Login.jpg");
}
.third{
  background-image: url("../assets/GAFA-Utilities.jpeg");
}
.cap{
  margin-left: 0px;
  margin-right: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
}
.cap2{
  margin-left: 0px;
  margin-right: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.2);
}

.adviser-link2 {
  width: 100px;
  height: 25px;
  color: white;
  border: 2px solid;
  font-size: 1.2rem!important;
  font-family: 'Abel', sans-serif;
  background-color: rgba( 255, 255, 255, 0.5 );
}
.adviser-link2:hover{
  background-color: white;
  border-color: white;
  color: rgb(69, 69, 69);
  cursor:pointer;
}

</style>